import { Injectable } from "@angular/core";

import { HttpClient, HttpHeaders } from "@angular/common/http";
import { AlertController, LoadingController } from "@ionic/angular";
import { Storage } from "@ionic/storage";
import * as CryptoJS from "crypto-js";
import { BehaviorSubject } from "rxjs";
import { environment } from "../../environments/environment";
import { STORAGE } from "../constant/storages";
import { errMsg } from "../text_control/error-msg";
import { BTN } from "../text_control/text_button";
import { _getStorage } from "../utils/local-storage";
import { ApiserviceService } from "./apiservice.service";
const keyCrypto = "6e01230e3c23c0ba9d45000e53f3ede6";

@Injectable({
  providedIn: "root",
})
export class AuthserviceService {
  private authenticated: BehaviorSubject<boolean> = new BehaviorSubject(false);

  authSubject = new BehaviorSubject(false);

  constructor(
    private http: HttpClient,
    public storage: Storage,
    public loadingController: LoadingController,
    public alertController: AlertController,
    public apiservice: ApiserviceService
  ) {}

  httpOptions = {
    headers: new HttpHeaders({
      client_id: "c182ea8aedb346e0bffc4e37fe3b74d4",
      client_secret: "65f9C3DE66c34538b0531C843Bc335Dc",
    }),
  };

  async loading() {
    const loading = await this.loadingController.create({
      message: "Please wait...",
    });
    await loading.present();
  }

  _login(apiUrl: any, data: any) {
    return new Promise(async (resolve, reject) => {
      const loading = await this.loadingController.create({
        message: "Please wait...",
      });
      await loading.present();

      let header = {};

      header["api-key"] = environment.apikey;
      // if (environment.production) {
      //   header["api-key"] = `${
      //     environment.pentest === true
      //       ? "01fc39fbb6fa408db327523ad59b9309"
      //       : "61f5e2c153f34f41b9772964dd6b7cb9"
      //   }`;
      // }
      header["Ocp-Apim-Trace"] = true;
      header["Content-Type"] = "application/text";

      let options = {
        headers: header,
      };

      console.log("web send Header [", options);
      const bodyRes = await this.encryptBody(data);
      this.http.post(apiUrl, bodyRes, options).subscribe(
        async (res: any) => {
          const bodyRes = await this.decryptBody(res);
          await loading.dismiss();
          resolve(bodyRes);
        },
        async (err) => {
          this.errorMsg(errMsg.error);
          await loading.dismiss();
          reject(err);
        }
      );
    });
  }
  async _get(apiUrl: any, data: any) {
    let header = {};
    const loading = await this.loadingController.create({
      message: "Please wait...",
    });
    await loading.present();
    header["api-key"] = environment.apikey;
    // if (environment.production) {
    //   header["api-key"] = `${
    //     environment.pentest === true
    //       ? "01fc39fbb6fa408db327523ad59b9309"
    //       : "61f5e2c153f34f41b9772964dd6b7cb9"
    //   }`;
    // }
    header["Ocp-Apim-Trace"] = true;
    header["Content-Type"] = "application/json";

    let options = {
      headers: header,
    };
    console.log("web send Header [", options);

    return new Promise((resolve, reject) => {
      this.http.post(apiUrl, data, options).subscribe(
        async (res) => {
          const bodyRes = await this.decryptBody(res);
          await loading.dismiss();
          resolve(bodyRes);
        },
        (err) => {
          reject(err);
          this.errorMsg(errMsg.error);
        }
      );
    });
  }

  _post(apiUrl: any, data: any) {
    return new Promise(async (resolve, reject) => {
      const loading = await this.loadingController.create({
        message: "Please wait...",
      });
      await loading.present();

      let header = {};

     header["api-key"] = environment.apikey;
      // if (environment.production) {
      //   header["api-key"] = `${
      //     environment.pentest === true
      //       ? "01fc39fbb6fa408db327523ad59b9309"
      //       : "61f5e2c153f34f41b9772964dd6b7cb9"
      //   }`;
      // }
      header["Ocp-Apim-Trace"] = true;
      header["Content-Type"] = "application/text";

      let options = {
        headers: header,
      };
      console.log("web send Header [", options);
      const bodyRes = await this.encryptBody(data);
      this.http.post(apiUrl, bodyRes, options).subscribe(
        async (res: any) => {
          const bodyRes = await this.decryptBody(res);
          await loading.dismiss();
          resolve(bodyRes);
        },
        async (err) => {
          await loading.dismiss();
          this.errorMsg(errMsg.error);
          reject(err);
        }
      );
    });
  }
  async errorMsg(message: string) {
    let alert = await this.alertController.create({
      cssClass: "my-custom-class",
      message: message,
      buttons: [
        {
          text: BTN.ok,
          cssClass: "alertButton",
        },
      ],
    });
    await alert.present();
  }

  async loginGetToken(url: string, token) {
    return new Promise(async (resolve) => {
      const loading = await this.loadingController.create({
        message: "Please wait...",
      });
      await loading.present();
      const header = await this.headerLogin(token);
      const options = {
        headers: header,
      };
      this.http.get(url, options).subscribe(
        async (res) => {
          await loading.dismiss();
          resolve(res);
        },
        async (err) => {
          await loading.dismiss();
          this.errorLogin(errMsg.errorLogin_ad2);
          resolve(err);
        }
      );
    });
  }

  async headerLogin(token) {
    let headers = {};
    headers["Ocp-Apim-Subscription-Key"] =
      environment.production === true
        ? "3ef9f23b48574f85944b0d19a40f5af2"
        : "97456e2ad389473ca78cecba1bd649f6";
    headers["App"] = "hrbi-etax";
    headers["Authorization"] = token;
    return headers;
  }

  async errorLogin(message: string) {
    let alert = await this.alertController.create({
      cssClass: "my-custom-class",
      message: message,
      buttons: [
        {
          text: BTN.ok,
          cssClass: "alertButton",
          handler: (blah) => {
            const url = this.apiservice.B2C_authority;
            window.location.replace(url);
          },
        },
      ],
    });
    await alert.present();
  }

  decryptBody(body: any) {
    var bytes = CryptoJS.AES.decrypt(body.api, keyCrypto);
    var originalText = bytes.toString(CryptoJS.enc.Utf8);
    return JSON.parse(originalText);
  }
  encryptBody(body: any) {
    const setType = JSON.stringify(body);
    const ciphertext = CryptoJS.AES.encrypt(setType, keyCrypto).toString();
    return ciphertext;
  }

  checkPermission(path: string) {
    const routePatterns: { [key: string]: string } = {
      "^/customer": "SUB_CUSTOMER",
      "^/configuration": "SUB_CONFIGSETUP",
      "^/role-management": "SUB_ROLESETUP",
      "^/seller": "SUB_SELLER",
      "^/credit-note": "ETAXCREDITNOTE",
      "^/tax-invoice": "ETAXFULLTAX",
      "^/no-tax-invoice": "ETAXFULLTAXNOTAXID",
      "^/inquiry": "ETAXINQUIRY",
      "^/replace": "ETAXREPLACE",
      "^/report": "ETAXREPORT",
      "^/resend": "ETAXRESEND",
    };
    const attemptedPath = path.split("?")[0];
    const permissions = _getStorage(STORAGE.modules);

    let permissionKey: string | null = null;
    for (const pattern in routePatterns) {
      const regex = new RegExp(pattern);
      if (regex.test(attemptedPath)) {
        permissionKey = routePatterns[pattern];
        break;
      }
    }

    if (!permissionKey) {
      return true;
    }

    if (permissionKey.startsWith("SUB_")) {
      if (
        !permissions["ETAXSUBCONFIG"] ||
        !permissions["ETAXSUBCONFIG"][permissionKey]
      ) {
        return false;
      }
    } else {
      if (!permissions[permissionKey]) {
        return false;
      }
    }
    return true;
  }
}
